export const questionsCategoryB: Record<string, PolicyFormQuestion> = {
  medicalHospitalTreatmentFirstInsured: {
    id: 'medical-hospital-treatment-first-insured',
    questionRef: 'medicalHospitalTreatmentFirstInsured',
    title:
      'During the past two (2) years has the proposed insured received medical treatment at a hospital?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalEmergencyRoomTreatmentFirstInsured: {
    id: 'medical-emergency-room-treatment-first-insured',
    questionRef: 'medicalEmergencyRoomTreatmentFirstInsured',
    title:
      'During the past two (2) years has the proposed insured received medical treatment at an emergency room?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNursingHomeAdmissionFirstInsured: {
    id: 'medical-nursing-home-admission-first-insured',
    questionRef: 'medicalNursingHomeAdmissionFirstInsured',
    title:
      'During the past two (2) years has the proposed insured been admitted to a nursing home?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNursingHomeRecommendationFirstInsured: {
    id: 'medical-nursing-home-recommendation-first-insured',
    questionRef: 'medicalNursingHomeRecommendationFirstInsured',
    title:
      'During the past two (2) years has a medical professional recommended nursing home or assisted living facility admission for the proposed insured?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceBathingFirstInsured: {
    id: 'medical-assistance-bathing-first-insured',
    questionRef: 'medicalAssistanceBathingFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: bathing?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceDressingFirstInsured: {
    id: 'medical-assistance-dressing-first-insured',
    questionRef: 'medicalAssistanceDressingFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: dressing?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceWalkingFirstInsured: {
    id: 'medical-assistance-walking-first-insured',
    questionRef: 'medicalAssistanceWalkingFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: walking?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceEatingFirstInsured: {
    id: 'medical-assistance-eating-first-insured',
    questionRef: 'medicalAssistanceEatingFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: eating?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceUsingToiletFirstInsured: {
    id: 'medical-assistance-using-toilet-first-insured',
    questionRef: 'medicalAssistanceUsingToiletFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: using toilet?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceGettingUpFirstInsured: {
    id: 'medical-assistance-getting-up-first-insured',
    questionRef: 'medicalAssistanceGettingUpFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: getting up and down?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceTakingMedicationFirstInsured: {
    id: 'medical-assistance-taking-medication-first-insured',
    questionRef: 'medicalAssistanceTakingMedicationFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: taking medication?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceShoppingFirstInsured: {
    id: 'medical-assistance-shopping-first-insured',
    questionRef: 'medicalAssistanceShoppingFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: shopping?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceCookingFirstInsured: {
    id: 'medical-assistance-cooking-first-insured',
    questionRef: 'medicalAssistanceCookingFirstInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: cooking?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPendingDiagnosticTestFirstInsured: {
    id: 'medical-pending-diagnostic-test-first-insured',
    questionRef: 'medicalPendingDiagnosticTestFirstInsured',
    title:
      'During the past two (2) years has the proposed insured been advised by a member of the medical profession to have any diagnostic test which has not been completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPendingHospitalizationFirstInsured: {
    id: 'medical-pending-hospitalization-first-insured',
    questionRef: 'medicalPendingHospitalizationFirstInsured',
    title:
      'During the past two (2) years has the proposed insured been advised by a member of the medical profession to have hospitalization which has not been completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPendingSurgeryFirstInsured: {
    id: 'medical-pending-surgery-first-insured',
    questionRef: 'medicalPendingSurgeryFirstInsured',
    title:
      'During the past two (2) years has the proposed insured been advised by a member of the medical profession to have surgery which has not been completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalClaimInjuryFirstInsured: {
    id: 'medical-claim-injury-first-insured',
    questionRef: 'medicalClaimInjuryFirstInsured',
    title:
      'During the past two (2) years has the proposed insured filed a claim for or received benefits for injury?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalClaimSicknessFirstInsured: {
    id: 'medical-claim-sickness-first-insured',
    questionRef: 'medicalClaimSicknessFirstInsured',
    title:
      'During the past two (2) years has the proposed insured filed a claim for or received benefits for sickness?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalClaimDisabilityFirstInsured: {
    id: 'medical-claim-disability-first-insured',
    questionRef: 'medicalClaimDisabilityFirstInsured',
    title:
      'During the past two (2) years has the proposed insured filed a claim for or received benefits for disability?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalInjuryFromFallFirstInsured: {
    id: 'medical-injury-from-fall-first-insured',
    questionRef: 'medicalInjuryFromFallFirstInsured',
    title:
      'During the past two (2) years has the proposed insured had any injury caused by falling?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
  medicalHospitalTreatmentSecondInsured: {
    id: 'medical-hospital-treatment-second-insured',
    questionRef: 'medicalHospitalTreatmentSecondInsured',
    title:
      'During the past two (2) years has the proposed insured received medical treatment at a hospital?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalEmergencyRoomTreatmentSecondInsured: {
    id: 'medical-emergency-room-treatment-second-insured',
    questionRef: 'medicalEmergencyRoomTreatmentSecondInsured',
    title:
      'During the past two (2) years has the proposed insured received medical treatment at an emergency room?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNursingHomeAdmissionSecondInsured: {
    id: 'medical-nursing-home-admission-second-insured',
    questionRef: 'medicalNursingHomeAdmissionSecondInsured',
    title:
      'During the past two (2) years has the proposed insured been admitted to a nursing home?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalNursingHomeRecommendationSecondInsured: {
    id: 'medical-nursing-home-recommendation-second-insured',
    questionRef: 'medicalNursingHomeRecommendationSecondInsured',
    title:
      'During the past two (2) years has a medical professional recommended nursing home or assisted living facility admission for the proposed insured?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceBathingSecondInsured: {
    id: 'medical-assistance-bathing-second-insured',
    questionRef: 'medicalAssistanceBathingSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: bathing?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceDressingSecondInsured: {
    id: 'medical-assistance-dressing-second-insured',
    questionRef: 'medicalAssistanceDressingSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: dressing?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceWalkingSecondInsured: {
    id: 'medical-assistance-walking-second-insured',
    questionRef: 'medicalAssistanceWalkingSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: walking?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceEatingSecondInsured: {
    id: 'medical-assistance-eating-second-insured',
    questionRef: 'medicalAssistanceEatingSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: eating?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceUsingToiletSecondInsured: {
    id: 'medical-assistance-using-toilet-second-insured',
    questionRef: 'medicalAssistanceUsingToiletSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: using toilet?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceGettingUpSecondInsured: {
    id: 'medical-assistance-getting-up-second-insured',
    questionRef: 'medicalAssistanceGettingUpSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: getting up and down?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceTakingMedicationSecondInsured: {
    id: 'medical-assistance-taking-medication-second-insured',
    questionRef: 'medicalAssistanceTakingMedicationSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: taking medication?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceShoppingSecondInsured: {
    id: 'medical-assistance-shopping-second-insured',
    questionRef: 'medicalAssistanceShoppingSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: shopping?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalAssistanceCookingSecondInsured: {
    id: 'medical-assistance-cooking-second-insured',
    questionRef: 'medicalAssistanceCookingSecondInsured',
    title:
      'During the past two (2) years has the proposed insured required assistance for a period longer than 2 weeks to perform daily activities: cooking?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPendingDiagnosticTestSecondInsured: {
    id: 'medical-pending-diagnostic-test-second-insured',
    questionRef: 'medicalPendingDiagnosticTestSecondInsured',
    title:
      'During the past two (2) years has the proposed insured been advised by a member of the medical profession to have any diagnostic test which has not been completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPendingHospitalizationSecondInsured: {
    id: 'medical-pending-hospitalization-second-insured',
    questionRef: 'medicalPendingHospitalizationSecondInsured',
    title:
      'During the past two (2) years has the proposed insured been advised by a member of the medical profession to have hospitalization which has not been completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalPendingSurgerySecondInsured: {
    id: 'medical-pending-surgery-second-insured',
    questionRef: 'medicalPendingSurgerySecondInsured',
    title:
      'During the past two (2) years has the proposed insured been advised by a member of the medical profession to have surgery which has not been completed?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalClaimInjurySecondInsured: {
    id: 'medical-claim-injury-second-insured',
    questionRef: 'medicalClaimInjurySecondInsured',
    title:
      'During the past two (2) years has the proposed insured filed a claim for or received benefits for injury?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalClaimSicknessSecondInsured: {
    id: 'medical-claim-sickness-second-insured',
    questionRef: 'medicalClaimSicknessSecondInsured',
    title:
      'During the past two (2) years has the proposed insured filed a claim for or received benefits for sickness?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalClaimDisabilitySecondInsured: {
    id: 'medical-claim-disability-second-insured',
    questionRef: 'medicalClaimDisabilitySecondInsured',
    title:
      'During the past two (2) years has the proposed insured filed a claim for or received benefits for disability?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  medicalInjuryFromFallSecondInsured: {
    id: 'medical-injury-from-fall-second-insured',
    questionRef: 'medicalInjuryFromFallSecondInsured',
    title:
      'During the past two (2) years has the proposed insured had any injury caused by falling?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
};
